import type {
  StatementsProvider,
  StatementsComponent,
} from '@/src/app/main/(tabs)/card/card-management/statements'
import { Api } from '@/src/store'
import { useCardAccount } from '@/src/experiences/card-accounts/hooks/useCardAccount'
import type { ID } from '@acre-rewards/lib'

export const PlatformStatements = (({ ToWrap }) => {
  const query = useCardAccount()

  return query.isLoading || query.isUninitialized ? (
    <ToWrap loading />
  ) : !query.isSuccess ? (
    <ToWrap error />
  ) : query.data[0]?.id ? (
    <StatementsWithCardAccount ToWrap={ToWrap} cardAccountId={query.data[0].id} />
  ) : (
    <ToWrap statements={[]} />
  )
}) satisfies StatementsProvider

function StatementsWithCardAccount({
  ToWrap,
  cardAccountId,
}: {
  ToWrap: StatementsComponent
  cardAccountId: ID.CardAccount
}) {
  const query = Api.endpoints['GET /card/:cardAccountId/statements'].useQuery({
    params: { cardAccountId },
  })

  return query.isLoading || query.isUninitialized ? (
    <ToWrap loading />
  ) : !query.isSuccess ? (
    <ToWrap error />
  ) : (
    <ToWrap statements={query.data} />
  )
}
